<div
  (mouseenter)="showFeedbackControls = true"
  (mouseleave)="showFeedbackControls = false"
  class="message-wrapper"
>
  <div class="flex message-box relative">
    <p *ngIf="!messageItem.from_stxt" class="message_time">
      {{ messageItem.timestamp | date: 'shortTime' }}
    </p>
    <ng-container *ngIf="messageItem?.category !== EMessageItemCategory.MEDIAS">
      <div
        (click)="clicked.emit()"
        (keydown.enter)="clicked.emit()"
        [ngClass]="{
          ai_message: messageItem.from_stxt,
          user_message: !messageItem.from_stxt,
          message_processing: isLoadingImage
        }"
        class="message flex items-center"
        tabindex="0"
      >
        <div class="flex space-between items-center">
          <p
            *ngIf="!messageItem.processing && !isLoadingImage"
            [innerHTML]="messageItem?.payload?.message"
            class="message_text"
          ></p>
          <stxt-play-voice-button
            #playMessage
            *ngIf="!isLoadingImage && messageItem.from_stxt && voiceSupported"
            [audio]="messageItem?.payload?.voice_url"
            [audioId]="messageItem.timestamp"
            [selectedMessageAudio]="selectedMessageAudio"
            [creatorId]="creatorId"
            [usageCase]="EPlayButtonUsage.ChatMessage"
            (voicePlaying)="trackMessagePlaying($event)"
            class="message_play"
          ></stxt-play-voice-button>
        </div>
        <div *ngIf="messageItem.processing || isLoadingImage" class="media_loader message_loader">
          <stxt-thumbnail-loader
            [usageCase]="EMediaLoaderType.Chat"
            [generationId]="messageItem.timestamp.toString()"
          ></stxt-thumbnail-loader>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="messageItem?.category === EMessageItemCategory.MEDIAS">
      <stxt-message-media
        [media]="messageItem.payload"
        [userId]="userId"
        [chatState]="chatState"
        [creatorName]="creatorName"
        [creatorId]="creatorId"
        (imagesLoaded)="mediaLoaded = true"
        (isPreviewMode)="isPreviewMode.emit($event)"
        (openPayment)="triggerPayment.emit()"
      ></stxt-message-media>
    </ng-container>
    <p *ngIf="messageItem.from_stxt" class="message_time">
      {{ messageItem.timestamp | date: 'shortTime' }}
    </p>
  </div>
  <div
    *ngIf="
      showFeedbackControls &&
      messageItem.from_stxt &&
      !isLoadingImage &&
      isFeedbackControlsEnabled &&
      messageItem.category !== EMessageItemCategory.MEDIAS
    "
    @feedbackAnimation
    class="message-feedback"
  >
    <stxt-feedback-controls
      [message]="messageItem"
      [creatorId]="creatorId"
      [userId]="userId"
      (click)="$event.stopPropagation()"
      (keydown.enter)="$event.stopPropagation()"
      tabindex="0"
    ></stxt-feedback-controls>
  </div>
</div>
